import { NavigateFunction } from 'react-router-dom';
import ErrorService from '../services/ErrorService';
import { signOutUser } from '../slices/AuthSlice';
import { showErrorToast } from '../slices/ToastNotificationSlice';
import { AppDispatch, ErrorCode } from '../types';
import { constructLink } from './UrlUtils';

interface HandleSessionExpirationParams {
  error: any;
  dispatch: AppDispatch;
  navigate: NavigateFunction;
  isAgentContext?: boolean;
  redirectTo?: string;
}

/**
 * Handles session expiration errors (401/403) by logging out and redirecting to login
 * @returns true if session expiration was handled, false otherwise
 */
export const handleSessionExpiration = async ({
  error,
  dispatch,
  navigate,
  isAgentContext = false,
  redirectTo,
}: HandleSessionExpirationParams): Promise<boolean> => {
  const errorCode = ErrorService.getErrorCode(error);

  if (
    errorCode === ErrorCode.UNAUTHORIZED ||
    errorCode === ErrorCode.FORBIDDEN
  ) {
    await dispatch(signOutUser());
    dispatch(showErrorToast('Your session has expired. Please log back in.'));
    navigate(
      constructLink(isAgentContext ? '/agent-login' : '/login', {
        redirectTo,
      }),
    );
    return true;
  }

  return false;
};

/**
 * Handles session expiration for 401 errors only (used in MFA pin verification)
 * @returns true if session expiration was handled, false otherwise
 */
export const handleUnauthorizedOnly = async ({
  error,
  dispatch,
  navigate,
  isAgentContext = false,
  redirectTo,
}: HandleSessionExpirationParams): Promise<boolean> => {
  const errorCode = ErrorService.getErrorCode(error);

  if (errorCode === ErrorCode.UNAUTHORIZED) {
    await dispatch(signOutUser());
    dispatch(showErrorToast('Your session has expired. Please log back in.'));
    navigate(
      constructLink(isAgentContext ? '/agent-login' : '/login', {
        redirectTo,
      }),
    );
    return true;
  }

  return false;
};
